import { useIntervalFn } from '@vueuse/core';
import dayjs from 'dayjs';
import { jwtDecode, type JwtPayload } from 'jwt-decode';
import { computed, ref } from 'vue';

import { useImpersonateToken } from '#domain/core/admin/composables/useImpersonateToken';

interface TimeRemainingInSessionType {
  seconds: number;
  formated: string;
}

export function useTimeRemainingInImpersonateSession() {
  const impersonateTokenStorage = useImpersonateToken();
  const impersonateSessionEndDate = computed(() => {
    const decodedToken = jwtDecode<JwtPayload>(impersonateTokenStorage.value);
    if (!decodedToken?.exp) {
      return null;
    }
    return dayjs.unix(decodedToken.exp);
  });

  const timeRemainingInSession = ref<TimeRemainingInSessionType | null>(null);

  useIntervalFn(() => {
    if (impersonateSessionEndDate.value) {
      const timeRemainingDuration = dayjs.duration(impersonateSessionEndDate.value.diff(dayjs(Date.now())));
      timeRemainingInSession.value = {
        seconds: timeRemainingDuration.asSeconds(),
        formated: timeRemainingDuration.format('mm:ss')
      };
    } else {
      timeRemainingInSession.value = null;
    }
  }, 1000);

  return timeRemainingInSession;
}
